import moment from 'moment'
import { Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { capitalize, setCurrency } from 'utils/utils'
import { Card } from './Card'

export const EmployeeProductivity = ({
    data,
    styleBar,
    isLoading,
    filter,
    onSubmitFilter,
    years,
}) => {
    return (
        <Card
            isLoading={isLoading}
            title='Productivity VS Salary Value'
            filterTitle='Filter Employee Productivity'
            initFilter={filter}
            initOptions={{ year: years }}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='gap-10 mt-4 relative'>
                <div className='flex items-center gap-6 pb-5'>
                    {Object.keys(data?.[0] || {}).map((key, index) => {
                        if (['period', 'total_salary_scaled'].includes(key)) return null

                        return (
                            <div key={index} className='flex items-center gap-2 min-w-fit'>
                                <div className='w-4 h-1' style={{ backgroundColor: styleBar(key) }} />
                                <div className='capitalize text-neutral-80'>
                                    {key === 'kpi' ? 'KPI' : capitalize(key.replaceAll('_', ' '))}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <ResponsiveContainer width='100%' height={240}>
                    <LineChart data={data}>
                        <XAxis dataKey='period' tickFormatter={(value) => moment(value).format('MMM')} />
                        <YAxis hide />
                        <Tooltip
                            labelFormatter={(value) => moment(value).format('MMMM')}
                            formatter={(value, name, props) => {
                                if (props.dataKey === 'kpi') return `${value}%`
                                return setCurrency(props.payload.total_salary)
                            }}
                        />

                        {/* Garis pembatas KPI vs Salary */}
                        <ReferenceLine y={100} stroke='#999' strokeDasharray='5 5' />

                        {/* KPI */}
                        <Line
                            type='monotone'
                            dataKey='kpi'
                            name='KPI'
                            stroke={styleBar('kpi')}
                            strokeWidth={3}
                            dot={false}
                        />

                        {/* Salary */}
                        <Line
                            type='monotone'
                            dataKey='total_salary_scaled'
                            name='Total Salary'
                            stroke={styleBar('total_salary')}
                            strokeWidth={3}
                            dot={false}
                        />
                    </LineChart>
                </ResponsiveContainer>

                {!data?.length && (
                    <div className='absolute inset-0 flex items-center justify-center font-semibold text-neutral-60'>
                        Data Not Available
                    </div>
                )}

                <div className='flex gap-1.5 items-center w-fit px-2 py-1 mx-auto bg-neutral-10 border border-neutral-20 rounded-lg'>
                    <div className='w-3 h-3 bg-green-50 rounded-full'></div>
                    <span className='text-primary-50 font-semibold'>{filter?.year}</span>
                </div>
            </div>
        </Card>
    )
}
